import React, { useMemo, createContext, useState } from 'react'

const initialState = { orderItem: {} }

const ReturnItemContext = createContext(initialState)

const ReturnItemContextProvider = ({ children }) => {
  const [orderItem, setOrderItem] = useState(initialState)
  const [returnQty, setReturnQty] = useState(0)
  const contextValue = useMemo(
    () => ({
      orderItem,
      setOrderItem,
      returnQty,
      setReturnQty,
    }),
    [orderItem, setOrderItem, returnQty, setReturnQty],
  )

  return (
    <ReturnItemContext.Provider value={contextValue}>
      {children}
    </ReturnItemContext.Provider>
  )
}

export { ReturnItemContext }
export default ReturnItemContextProvider
